


import { setGetMailingStatisticsCountGameAction } from '../action';
import { getMailingStatisticsCountGame } from '../api/getMailingStatisticsCountGame';

export const setGetMailingStatisticsCountGame = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsCountGame(params);

            dispatch(setGetMailingStatisticsCountGameAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}